import CasusPage from "./CasusPage"

export default CasusPage
